import { Box } from '@factorialco/deprecated-design-system'
import { People } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import ExpensesGroupsSection from 'modules/expenses/pages/settings/Content/ExpensesGroups'
import SectionInfo from 'modules/expenses/pages/settings/ExpensePolicy/Components/_SectionInfo'

interface Props {
  hasExpensesGroupsFeature: boolean
  isExpensesGroupsEnabled: boolean
}

const SpendingGroups = ({ hasExpensesGroupsFeature, isExpensesGroupsEnabled }: Props) => {
  return (
    <Box flexDirection="column" gap="s24" paddingX="s24" flexGrow>
      <SectionInfo
        icon={People}
        title={i18n.t('expenses_v2.settings.expenses_groups.title')}
        description={i18n.t('expenses_v2.settings.expenses_groups.description')}
      />

      <ExpensesGroupsSection
        hasExpensesGroupsFeature={hasExpensesGroupsFeature}
        isExpensesGroupsEnabled={isExpensesGroupsEnabled}
        hideTitle
      />
    </Box>
  )
}

export default SpendingGroups
